export const SHOW_USERPERSONA_MODAL = 'SHOW_USERPERSONA_MODAL';
export const DISMISS_USERPERSONA_MODAL = 'DISMSS_USERPERSONA_MODAL';
export const CLOSE_USERPERSONA_MODAL = 'CLOSE_USERPERSONA_MODAL';
export const SUBMIT_USERPERSONA_MODAL = 'SUBMIT_USERPERSONA_MODAL';

export const showUserpersonaModal = () => ({
  type: SHOW_USERPERSONA_MODAL
});

export const dismissUserpersonaModal = () => ({
  type: DISMISS_USERPERSONA_MODAL
});

export const closeUserpersonaModal = () => ({
  type: CLOSE_USERPERSONA_MODAL
});

export const submitUserpersona = answers => ({
  type: SUBMIT_USERPERSONA_MODAL,
  answers
});
